import { render, staticRenderFns } from "./AcceptOrdersModal.vue?vue&type=template&id=74d04652&"
import script from "./AcceptOrdersModal.vue?vue&type=script&lang=js&"
export * from "./AcceptOrdersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports